const isValidToken = (accessToken) => {
  if (!accessToken) {
    return false;
  }

  // Vérifie l'expiration du JWT Passport. Avant, cette fonction renvoyait
  // toujours `true` → un token expiré était accepté au boot, l'app se croyait
  // authentifiée puis enchaînait des 401 (cf. spinner infini). Décodage inline
  // du payload base64url (pas de dépendance jwt-decode). Si le token n'est pas
  // décodable, on le considère valide : le filet de sécurité est le rejet du
  // 401 dans ApiService.request().
  try {
    const payload = accessToken.split('.')[1];
    if (!payload) {
      return true;
    }
    const decoded = JSON.parse(atob(payload.replace(/-/g, '+').replace(/_/g, '/')));
    if (!decoded.exp) {
      return true;
    }
    return decoded.exp > Date.now() / 1000;
  } catch {
    return true;
  }
};

const setSession = (accessToken) => {
  if (accessToken) {
    localStorage.setItem('accessToken', accessToken);
  } else {
    localStorage.removeItem('accessToken');
  }
};

export { isValidToken, setSession };
